export default "__VITE_ASSET__C9bxO4nu__"